import $ from 'jquery';
import {isMobile} from '../utilities'
var DS = DS || {};
MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

DS.product = function(){
  var els = {};

  var openCartModal = function(){
    els.weqModal.addClass('open');
    els.productCost.text("$" + els.nypInput.val());
  }

  return {
    init: function(){
      els = {
        cartMessage: $('.woocommerce-message'),
        weqModal: $('#weq-modal'),
        nypInput: $('#nyp'),
        productCost: $('.weq-modal-content .product-cost')
      };
      if (els.cartMessage[0]) {
        openCartModal();
      }
    }

  }

}
$(function() {
  if ($('.product-template-default')[0]) {
    var product = new DS.product();
    product.init();
  }
});
